import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ManageUsersPanel from "../admin/manageUsersPanel.tsx";
import CardManagementPanel from "./cardManagementPanel.tsx";
import { Link } from "react-router-dom";

export default function Owner() {
    return (
        <Container className="my-4 pt-2 pb-2">
            <Row className='mb-4 align-items-center'>
                <Col>
                    <h2 className='mb-0'>Owner Management</h2>
                    <p className='text-muted'>Access high-level system operations.</p>
                </Col>
                <Col xs='auto'>
                    <Link to='/home' className='btn btn-outline-secondary btn-sm'>
                        Back to Home
                    </Link>
                </Col>
            </Row>

            {/* Render the Card Management Panel */}
            <CardManagementPanel />

            {/* Render the User Management Panel with owner access */}
            <ManageUsersPanel owner={true} />
        </Container>
    );
}